import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import RoyaltiesService from "../services/RoyaltiesService";

const useRoyaltyService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new RoyaltiesService(client);
  }, [client]);

  return service;
};

export default useRoyaltyService;
